import {object, string} from 'yup'

export const signInSchema = object({
    email: string()
        .trim()
        .required('Required')
        .email('Invalid Email'),

    password: string()
        .trim()
        .required('Required')
});
